   // src/redux/slices/userDataSlice.js
   import { createSlice } from '@reduxjs/toolkit';

   const userDataSlice = createSlice({
     name: 'userData',
     initialState: null, // Başlangıç durumu
     reducers: {
       setUserData: (state, action) => action.payload,
       clearUserData: () => null,
     },
   });

   export const { setUserData, clearUserData } = userDataSlice.actions;

   export const selectUserData = (state) => state.userData;

   export default userDataSlice.reducer;